import React from 'react';
import { motion } from 'framer-motion';
const TESTIMONIALS = [{
  initials: 'MG',
  text: 'Compré el pack un domingo a la noche. El lunes tenía todo el año de Português organizado. Las secuencias son exactamente lo que necesitaba.',
  author: 'Mariela G.',
  location: 'Córdoba'
}, {
  initials: 'FL',
  text: 'Lo que más valoro es que está organizado por nivel y en Português Brasileiro, no de Portugal. Mis alumnos finalmente entienden por qué estudian este idioma.',
  author: 'Fernando L.',
  location: 'Tucumán'
}, {
  initials: 'LP',
  text: 'Como profe lo que más me cambió fue el tomo de Fonética. Mis alumnos por fin pronuncian bien porque el contenido los conecta con el portugués real.',
  author: 'Laura P.',
  location: 'Rosario'
}, {
  initials: 'PA',
  text: 'Los módulos VIP de Negocios me abrieron un nicho que no sabía que existía. Ya conseguí mi primer cliente corporativo usando el material del bonus.',
  author: 'Pablo A.',
  location: 'Neuquén'
}, {
  initials: 'SC',
  text: 'Tenía miedo de que fuera material genérico. Pero cuando abrí el Tomo 1 encontré exactamente lo que le falta al alumno argentino: la comparación sistemática con el español rioplatense.',
  author: 'Sofía C.',
  location: 'La Plata'
}, {
  initials: 'RM',
  text: 'El Método Viajero Express fue lo que terminó de convencerme. En una semana ya tenía un alumno inscripto en el pack de 4 clases a precio premium.',
  author: 'Roberto M.',
  location: 'Buenos Aires'
}];
export function TestimonialsFull() {
  return <section className="w-full bg-white py-20 px-4" data-id="element-323">
      <div className="max-w-6xl mx-auto" data-id="element-324">
        <div className="text-center mb-16" data-id="element-325">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-3xl font-bold text-deep-green mb-4" data-id="element-326">
            Lo que dicen los docentes de Português que ya tienen su pack:
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-500" data-id="element-327">
            +500 docentes de Argentina ya lo usan
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-328">
          {TESTIMONIALS.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-329">
              <div className="flex items-center gap-3 mb-4" data-id="element-330">
                <div className="w-10 h-10 rounded-full bg-deep-green flex items-center justify-center text-white font-bold text-sm" data-id="element-331">
                  {t.initials}
                </div>
                <div className="flex text-gold text-sm" data-id="element-332">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed mb-6 italic flex-grow" data-id="element-333">
                "{t.text}"
              </p>
              <div className="text-xs text-gray-500 font-medium" data-id="element-334">
                — {t.author} | 📍 {t.location}
                <br data-id="element-335" />
                Docente de Português
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}